<template>
  <div
    v-if="(category.estado=='P')||(userLogged.profile=='ADMINISTRADOR')"
    class="card categoria"
    :style="[category.styleObject]"
  >
    <div v-if="userLogged.profile == 'ADMINISTRADOR'">
      <a class="estado-borrador" v-if="category.estado==='B'">borrador</a>
      <a class="estado-publicado" v-if="category.estado==='P'">publicado</a>
    </div>
    <router-link :to="'/Categoria/'+category.id" tag="div" v-if="userLogged.profile != 'ADMINISTRADOR'">
      <img :src="'../'+category.imagen" class="img-categoria" alt="Arkidia" />
    </router-link>
    <img
      :src="'../'+category.imagen"
      class="img-categoria"
      alt="Arkidia"
      v-if="userLogged.profile == 'ADMINISTRADOR'"
    />

    <div class="card-body">
      <h3 class="texto-car-categoria text-white">{{ category.nombre }}</h3>
    </div>

    <div v-if="userLogged.profile == 'ADMINISTRADOR'">
      <a href="#" @click="modificarModal()" style="color:white; padding:15px">Modificar</a>
      <a href="#" @click="eliminarModal()" style="color:white; padding:15px">Eliminar</a>
    </div>

    <b-modal ref="eliminar-modal" hide-footer title="Eliminar Categoría">
      <div class="d-block text-center">
        <h5>¿Estás seguro que querés eliminar la categoría {{category.nombre}}?</h5>
      </div>
      <b-button class="mt-3" variant="danger" block @click="eliminarCategoria(category)">Eliminar</b-button>
      <b-button class="mt-2" variant="warning" block @click="cerrarEliminar">Cerrar</b-button>
    </b-modal>

    <b-modal ref="modificar-modal" hide-footer title="Modificar Categoría">
      <div class="d-block">
        <div class="form-group">
          <label>Nombre de la categoría</label>
          <input class="form-control" v-model="category.nombre" />
        </div>

        <div class="form-group">
          <label>Link a la imagen</label>
          <input class="form-control" v-model="category.imagen" />
        </div>

        <div class="form-group">
          <label>Color en hexadecimal (sin #)</label>
          <input class="form-control" v-model="category.color" />
        </div>

        <div class="form-group">
          <label>Link al video</label>
          <input class="form-control" v-model="category.video" />
        </div>

        <input type="radio" id="borrador" value="B" v-model="category.estado" />
        <label for="borrador">Borrador</label>
        <br />
        <input type="radio" id="publicado" value="P" v-model="category.estado" />
        <label for="publicado">Publicado</label>
        <br />

        <div v-if="errorMessage" class="alert alert-danger" role="alert">{{errorMessage}}</div>
      </div>
      <b-button class="mt-3" variant="primary" block @click="modificarCategoria(category)">Modificar</b-button>
    </b-modal>
  </div>
</template>


<script>
import { mapGetters } from "vuex";

export default {
  props: ["category"],
  data() {
    return {
      eliminaCategoria: "",
      errorMessage: ""
    };
  },
  computed: {
    ...mapGetters([
      "categorias",
      "userLogged",
      "pathAPI",
      "categoriaSeleccionada"
    ])
  },
  methods: {
    verCategoria(categoria) {
      if (this.userLogged.profile == "ADMINISTRADOR") {
        this.$refs["modificar-modal"].show();
      } else {
        this.$store.state.categoriaSeleccionada = categoria;
        sessionStorage.categoriaSel = categoria.id;
        this.$router.push({ path: "/Categoria" });
      }
    },

    eliminarCategoria(category) {
      var fetchApi =
        this.pathAPI +
        "categorias.php?id_categoria=" +
        category.id +
        "&usuario=" +
        this.userLogged.user;
      fetch(fetchApi, {
        method: "DELETE"
      }).then(() => {
        var i;
        for (i = 0; i < this.categorias.length; i++) {
          this.categorias[i];
          if (this.categorias[i].nombre == category.nombre) {
            this.categorias.splice(i, 1);
          }
        }
        this.$refs["eliminar-modal"].hide();
      });
    },

    modificarCategoria(categoria) {
      var bodyApi;
      bodyApi =
        "usuario=" +
        this.userLogged.user +
        "&id_categoria=" +
        categoria.id +
        "&descripcion=" +
        categoria.nombre +
        "&imagen_categoria=" +
        categoria.imagen +
        "&color=" +
        categoria.color +
        "&link_video=" +
        categoria.video +
        "&estado=" +
        categoria.estado;
      fetch(this.pathAPI + "categorias.php?" + bodyApi, {
        method: "PUT",
        headers: new Headers({
          "Content-Type": "application/x-www-form-urlencoded"
        })
      })
        .then(response => response.json())
        .then(data => {
          if (data.resultado == "OK") {
            var i;
            for (i = 0; i < this.categorias.length; i++) {
              this.categorias[i];
              if (this.categorias[i].id == categoria.id) {
                this.categorias[i].nombre = categoria.nombre;
                this.categorias[i].imagen = categoria.imagen;
                this.categorias[i].color = categoria.color;
                this.categorias[i].video = categoria.video;
                this.categorias[i].estado = categoria.estado;
                this.categorias[i].styleObject.backgroundColor =
                  "#" + categoria.color;
              }
            }

            this.$refs["modificar-modal"].hide();
          } else {
            this.errorMessage = "Verificá los datos ingresados";
          }
        });
    },

    eliminarModal() {
      this.$refs["eliminar-modal"].show();
    },
    modificarModal() {
      this.$refs["modificar-modal"].show();
    },
    cerrarEliminar() {
      this.$refs["eliminar-modal"].hide();
    },
    cerrarModificar() {
      this.$refs["modificar-modal"].hide();
    }
  }
};
</script>

<style scoped>
.estado-borrador {
  border-radius: 15px;
  color: #ffffff !important;
  background: #ce7d00;
  margin: 10px;
  padding-left: 30px;
  padding-right: 30px;
  padding-top: 10px;
  padding-bottom: 10px;
}
.estado-noCreado {
  border-radius: 15px;
  color: #ffffff !important;
  background: #ce1f00;
  margin: 15px;
  padding-left: 15px;
  padding-right: 15px;
}

.estado-publicado {
  border-radius: 15px;
  color: #ffffff !important;
  background: #16bc0c;
  margin: 10px;
  padding-left: 30px;
  padding-right: 30px;
  padding-top: 10px;
  padding-bottom: 10px;
}

.img-categoria {
  width: 200px;
}

@media screen and (max-width: 600px) {
  .img-categoria {
    width: 100px;
  }

  .categoria {
    width: 120px;
  }

  .texto-car-categoria {
    font-size: 18px;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/categories/Category.vue